const cs = {
  // Generic
  "generic.add": "Přidat",
  "generic.cancel": "Zrušit",

  // BlockType
  "components.controls.blocktype.h1": "Nadpis 1",
  "components.controls.blocktype.h2": "Nadpis 2",
  "components.controls.blocktype.h3": "Nadpis 3",
  "components.controls.blocktype.h4": "Nadpis 4",
  "components.controls.blocktype.h5": "Nadpis 5",
  "components.controls.blocktype.h6": "Nadpis 6",
  "components.controls.blocktype.blockquote": "Citace",
  "components.controls.blocktype.code": "Kód",
  "components.controls.blocktype.blocktype": "Styl",
  "components.controls.blocktype.normal": "Text",

  // Color Picker
  "components.controls.colorpicker.colorpicker": "Barva",
  "components.controls.colorpicker.text": "Text",
  "components.controls.colorpicker.background": "Zvýraznění",

  // FontSize
  "components.controls.fontsize.fontsize": "Velikost",

  // History
  "components.controls.history.history": "Historie",
  "components.controls.history.undo": "Zpět",
  "components.controls.history.redo": "Opakovat",


  // Inline
  "components.controls.inline.bold": "Tučný",
  "components.controls.inline.italic": "Kurziva",
  "components.controls.inline.underline": "Podtržený",
  "components.controls.inline.strikethrough": "Přeškrtnutý",
  "components.controls.inline.monospace": "Monospace",

  // Link
  "components.controls.link.linkTitle": "Název odkazu",
  "components.controls.link.linkTarget": "Cíl odkazu",
  "components.controls.link.linkTargetOption": "Otevřít v novém okně",
  "components.controls.link.link": "Odkaz",
  "components.controls.link.unlink": "Odebrat odkaz",

  // List
  "components.controls.list.list": "Seznam",
  "components.controls.list.unordered": "Nečíslovaný seznam",
  "components.controls.list.ordered": "Číslovaný seznam",

  // Remove
  "components.controls.remove.remove": "Odstranit stylování",

  // TextAlign
  "components.controls.textalign.textalign": "Zarovnání",
  "components.controls.textalign.left": "Zleva",
  "components.controls.textalign.center": "Centrované",
  "components.controls.textalign.right": "Zprava",
  "components.controls.textalign.justify": "Do bloku"
};

export default cs;
